import React from "react";
import { Close } from "@material-ui/icons";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@material-ui/core";

function NoTemplateModal({
    closePopup,
    openPopup,
}) {
    return (
        <div>
            <Dialog
                open={openPopup}
                onClose={closePopup}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'>
                <DialogTitle id='alert-dialog-title'>
                    Template Not Supported
                    <Close className='closePopup' onClick={closePopup} />
                </DialogTitle>
                <DialogContent className='addLaunchPopupWrapper'>
                    <Typography>
                        Templates are not supported on Facebook and Instagram. Please use plain text only.
                    </Typography>
                </DialogContent>
                <DialogActions className='popupFooter addCatFooter'>
                    <Button
                        onClick={closePopup}
                        color='primary'
                        variant='contained'
                        autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default NoTemplateModal;
